module.exports = __webpack_public_path__ + "img/restaurantampel.bf623ef7.jpg";